import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-politicas-de-privacidade',
  templateUrl: './politicas-de-privacidade.component.html',
  styleUrls: ['./politicas-de-privacidade.component.scss']
})
export class PoliticasDePrivacidadeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
